import React from 'react'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import Switcher from 'commons/js/ui/Switcher'
import { Flex } from '@elparking/components'
import { FILTER_ALL, FILTER_MOWIZTRUCK } from '../SearchForm'

const MowizTruckSwitcher = ({ onChange, selected }) => {
    return <Flex flex={['1 1 100%']} flexWrap='wrap' mt='1em' justifyContent='start' w='100%'>
        <Switcher
          primaryOption={{value: FILTER_ALL, label: <FormattedMessage defaultMessage='Todos los parkings' />}}
          secondaryOption={{value: FILTER_MOWIZTRUCK, label: <FormattedMessage defaultMessage='Solo red mowiz TRUCK' />}}
          selected={selected ? FILTER_MOWIZTRUCK : FILTER_ALL }
          onChange={onChange} />
    </Flex>
}

MowizTruckSwitcher.propTypes = {
    onChange: PropTypes.func,
    selected: PropTypes.bool,
}

MowizTruckSwitcher.defaultProps = {
    selected: false,
    onChange: () => {},
}

export default MowizTruckSwitcher
